import Model from '@/models/Model'

export default class AEdit extends Model {
    resource() {
        return 'edit'
    }
}